/** GMO convenience-store brand identifiers sent as `paymentMethod` in GMO CVS requests. */
export enum ConbiniBrand {
  LAWSON = 'conbini-lawson',
  SEVEN_ELEVEN = 'conbini-seven-eleven',
  FAMILY_MART = 'conbini-family-mart',
  MINI_STOP = 'conbini-mini-stop',
  SEICOMART = 'conbini-seicomart',
}
